import { render, staticRenderFns } from "./ConfigSidebar.vue?vue&type=template&id=e331b8d0&scoped=true&"
import script from "./ConfigSidebar.vue?vue&type=script&lang=js&"
export * from "./ConfigSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSidebar.vue?vue&type=style&index=0&id=e331b8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e331b8d0",
  null
  
)

export default component.exports